import React from "react";
import { Modal, FormControl } from "react-bootstrap";
import "./MedicineWiseBatchersSelect.css";
import Swal from "sweetalert2";

const PharmacyVerifiedModal = ({
  show,
  onHide,
  pharmacyVerifiedData,
  onSubmitPharmacyVerified,
  isSubmitting,
  getStoreId,
}) => {
  // console.log(getStoreId, "store id");
  const claimData =
    (pharmacyVerifiedData && pharmacyVerifiedData.data) ||
    pharmacyVerifiedData ||
    {};
  const medication = (claimData && claimData.medication) || {};
  const storeWiseMedication =
    (claimData && claimData.store_wise_medication) || [];
  const batches = (claimData && claimData.batches) || [];

  const stockByStore = storeWiseMedication.reduce((acc, row) => {
    acc[Number(row && row.store_id)] = Number((row && row.quantity) || 0);
    return acc;
  }, {});

  // React.useEffect(() => {
  //   if (show) {
  //   }
  // }, [show, getStoreId]);
  React.useEffect(() => {
    if (show) {
      console.log(getStoreId, "store id");
    }
  }, [show]);
  let pharmacyTotalStock = 0;
  let warehouseTotalStock = 0;
  if (Array.isArray(storeWiseMedication)) {
    storeWiseMedication.forEach((row) => {
      if (
        row &&
        row.pharmacies &&
        row.pharmacies.name === "Flash Health Pharmacy"
      ) {
        pharmacyTotalStock = Number(row.quantity) || 0;
      }
      if (row && row.pharmacies && row.pharmacies.name === "Flash WareHouse") {
        warehouseTotalStock = Number(row.quantity) || 0;
      }
    });
  }
  const medicineDisplay = `${medication.title || ""}${
    medication.item_code ? ` (${medication.item_code})` : ""
  }`;

  const [editablePackSize, setEditablePackSize] = React.useState("");
  const [editableBatchRows, setEditableBatchRows] = React.useState([]);
  const [enterQty, setEnterQty] = React.useState("");
  const [scanBatchNo, setScanBatchNo] = React.useState("");
  const [highlightedBatchNo, setHighlightedBatchNo] = React.useState("");
  const scanInputRef = React.useRef(null);

  React.useEffect(() => {
    setEditablePackSize(String(medication.pack_size || ""));
  }, [medication.pack_size, show]);

  React.useEffect(() => {
    const mappedRows = (batches || []).map((batch) => ({
      ...batch,
      release_qty: Number(batch && batch.quantity) || 0,
      received_qty: "",
    }));
    setEditableBatchRows(mappedRows);
  }, [batches, show]);

  React.useEffect(() => {
    if (!show) return;
    const timer = setTimeout(() => {
      if (
        scanInputRef.current &&
        typeof scanInputRef.current.focus === "function"
      ) {
        scanInputRef.current.focus();
      }
    }, 120);
    return () => clearTimeout(timer);
  }, [show]);

  const totalOriginalQty = editableBatchRows.reduce(
    (sum, row) => sum + (Number(row.quantity) || 0),
    0,
  );

  const totalReleasedStock = editableBatchRows.reduce(
    (sum, row) => sum + (Number(row.release_qty) || 0),
    0,
  );

  const totalReceivedStock = editableBatchRows.reduce(
    (sum, row) => sum + (Number(row.received_qty) || 0),
    0,
  );

  const handleCancel = () => {
    if (isSubmitting) return;
    setEditablePackSize("");
    setEditableBatchRows([]);
    setEnterQty("");
    setScanBatchNo("");
    setHighlightedBatchNo("");
    onHide();
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;

    const requestId = String(
      (claimData && claimData.id) ||
        (pharmacyVerifiedData && pharmacyVerifiedData.id) ||
        "",
    );
    const medicationId = Number(
      (claimData && claimData.medication_id) ||
        (medication && medication.id) ||
        0,
    );
    const requestBy = Number((claimData && claimData.request_by) || 0);
    const storeId = Number((claimData && claimData.store_id) || getStoreId);

    if (!requestId || !medicationId) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Invalid pharmacy verification data</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const normalizedBatches = (editableBatchRows || [])
      .map((row) => ({
        id: Number((row && row.id) || medicationId),
        batch_no: String((row && row.batch_no) || ""),
        expiry_date: String((row && row.expiry_date) || ""),
        quantity:
          Number((row && row.received_qty) || 0) === 0
            ? Number(enterQty)
            : Number((row && row.received_qty) || 0),
      }))
      .filter((batch) => batch.batch_no && batch.quantity > 0);

    if (
      normalizedBatches.length === 0 &&
      (!enterQty || Number(enterQty) === 0)
    ) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Received quantity is required</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const tagPayload = {
      id: requestId,
      status: 4,
      medication_id: medicationId,
      medications: {
        medication_id: medicationId,
        quantity: Number(
          (claimData && claimData.utilization_quantity) ||
            totalOriginalQty ||
            0,
        ),
        received_quantity:
          totalReceivedStock === 0 && Number(enterQty) > 0
            ? Number(enterQty)
            : totalReceivedStock,
        batches: normalizedBatches,
      },
      release_qty:
        totalReceivedStock === 0 && Number(enterQty) > 0
          ? Number(enterQty)
          : totalReceivedStock,
      request_by: requestBy,
      store_id: getStoreId,
    };

    if (typeof onSubmitPharmacyVerified === "function") {
      await onSubmitPharmacyVerified(tagPayload);
    }
  };

  const updateBatchValue = (index, key, value) => {
    setEditableBatchRows((prevRows) => {
      const rows = [...prevRows];
      const row = rows[index] || {};
      const rowMaxQty = Number(row.quantity) || 0;
      if (value === "") {
        if (key === "received_qty") {
          rows[index] = {
            ...rows[index],
            received_qty: "",
            release_qty: rowMaxQty,
            is_deducted: false,
          };
        } else if (key === "release_qty") {
          rows[index] = {
            ...rows[index],
            release_qty: "",
            received_qty: rowMaxQty,
            is_deducted: false,
          };
        }
        return rows;
      }

      const numericValue = Math.min(Math.max(0, Number(value) || 0), rowMaxQty);

      if (key === "received_qty") {
        rows[index] = {
          ...rows[index],
          received_qty: numericValue,
          release_qty: Math.max(rowMaxQty - numericValue, 0),
        };
      } else if (key === "release_qty") {
        rows[index] = {
          ...rows[index],
          release_qty: numericValue,
          received_qty: Math.max(rowMaxQty - numericValue, 0),
        };
      }

      rows[index].is_deducted = Number(rows[index].release_qty || 0) === 0;
      return rows;
    });
  };

  const handleBatchScan = async () => {
    const scannedValue = String(scanBatchNo || "").trim();
    if (!scannedValue) return;

    const packSize = Math.max(0, Number(editablePackSize) || 0);
    if (packSize <= 0) {
      setScanBatchNo("");
      return;
    }

    setEditableBatchRows((prevRows) => {
      const rows = [...prevRows];
      const matchIndex = rows.findIndex(
        (row) =>
          String((row && row.batch_no) || "").toLowerCase() ===
          scannedValue.toLowerCase(),
      );

      if (matchIndex === -1) return rows;

      const currentRow = rows[matchIndex] || {};
      const currentReleaseQty = Number(currentRow.release_qty) || 0;
      const currentReceivedQty = Number(currentRow.received_qty) || 0;

      const movedQty = Math.min(packSize, currentReleaseQty);
      const nextReleaseQty = Math.max(currentReleaseQty - movedQty, 0);
      const nextReceivedQty = currentReceivedQty + movedQty;

      rows[matchIndex] = {
        ...currentRow,
        release_qty: nextReleaseQty,
        received_qty: nextReceivedQty,
        is_deducted: nextReleaseQty === 0,
      };

      return rows;
    });
    const hasMatchedBatch = (editableBatchRows || []).some(
      (row) =>
        String((row && row.batch_no) || "").toLowerCase() ===
        scannedValue.toLowerCase(),
    );

    if (!hasMatchedBatch) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Batch not found</div>",
        html: "<div style='font-size:16px;'>Cannot find the scanned batch.</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      setHighlightedBatchNo("");
      setScanBatchNo("");
      return;
    }

    setHighlightedBatchNo(scannedValue);
    setScanBatchNo("");
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      bsSize="lg"
      backdrop="static"
      dialogClassName="medicine-wise-batchers-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {Number(claimData.status) === 3 ? "Receive stock" : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="padding">
          <div className="modal-parent-style">
            <div style={{ flex: -0.95 }}>
              <div className="header-modal">Scan To Collect Medicine</div>
              <FormControl
                type="text"
                name="batch_no"
                placeholder="Scan Batch No"
                inputRef={(el) => {
                  scanInputRef.current = el;
                }}
                value={scanBatchNo}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.trimStart().startsWith("-")) {
                    e.target.value = scanBatchNo;
                    return;
                  }
                  setScanBatchNo(value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleBatchScan();
                  }
                }}
                style={{ height: "48px", fontSize: "16px" }}
              />
            </div>
            <div style={{ flex: 2.35 }}>
              <div className="header-modal"> medicine name</div>
              <FormControl
                type="text"
                name="medicine_name"
                value={medicineDisplay}
                readOnly
                className="medicine-name-style"
              />
            </div>
            <div style={{ flex: 0.8 }}>
              <div className="header-modal">Pharmacy Total Stock</div>
              <FormControl
                type="text"
                name="pharmacy_stock"
                value={pharmacyTotalStock}
                readOnly
                style={{
                  color: "black",
                  fontWeight: "800",
                  height: "48px",
                  fontSize: "16px",
                }}
              />
            </div>
            <div style={{ flex: 0.8 }}>
              <div className="header-modal">Pack Size</div>
              <FormControl
                type="text"
                name="pack_size"
                inputMode="numeric"
                pattern="[0-9]*"
                value={editablePackSize}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[0-9]*$/.test(value)) {
                    setEditablePackSize(value);
                  } else {
                    e.target.value =
                      editablePackSize == null ? "" : editablePackSize;
                  }
                }}
                style={{
                  color: "black",
                  fontWeight: "800",
                  height: "48px",
                  fontSize: "16px",
                }}
              />
            </div>
            <div style={{ flex: 0.8 }}>
              <div className="header-modal">Released Total Stock</div>

              <FormControl
                type="text"
                name="warehouse_stock"
                value={
                  !editableBatchRows || editableBatchRows.length === 0
                    ? Math.max(
                        (Number(claimData.utilization_quantity) || 0) -
                          (Number(enterQty) || 0),
                        0,
                      )
                    : totalReleasedStock && totalReleasedStock !== 0
                      ? totalReleasedStock
                      : claimData.utilization_quantity || ""
                }
                readOnly
                style={{
                  border:
                    Number(enterQty || 0) > 0 ||
                    (!editableBatchRows || editableBatchRows.length === 0
                      ? (Number(claimData.utilization_quantity) || 0) -
                        (Number(enterQty) || 0)
                      : totalReleasedStock && totalReleasedStock !== 0
                        ? totalReleasedStock
                        : claimData.utilization_quantity || 0) <
                      totalOriginalQty
                      ? "2px solid red"
                      : "",

                  backgroundColor:
                    Number(enterQty || 0) > 0 ||
                    (!editableBatchRows || editableBatchRows.length === 0
                      ? (Number(claimData.utilization_quantity) || 0) -
                        (Number(enterQty) || 0)
                      : totalReleasedStock && totalReleasedStock !== 0
                        ? totalReleasedStock
                        : claimData.utilization_quantity || 0) <
                      totalOriginalQty
                      ? "rgb(255, 191, 168)"
                      : "",
                }}
                className="paren-request-total-stock-style"
              />
              <p className="Request-Total-Stock-style">
                Warehouse Stock {warehouseTotalStock}
              </p>
            </div>
            {(!editableBatchRows || editableBatchRows.length === 0) && (
              <div style={{ flex: 0.8 }}>
                <div className="header-modal">Received Stock</div>
                <FormControl
                  style={{
                    fontWeight: "800",
                    fontSize: "16px",
                    textAlign: "center",
                    border:
                      Number(enterQty) > 0 ? "2px solid rgb(80, 181, 87)" : "",
                    backgroundColor:
                      Number(enterQty) > 0 ? "rgb(229, 255, 232)" : "",
                  }}
                  type="number"
                  min="0"
                  max={Number(claimData.utilization_quantity) || 0}
                  value={enterQty}
                  onChange={(e) => {
                    const max = Number(claimData.utilization_quantity) || 0;
                    let value = e.target.value.replace(/^0+/, "");
                    if (value === "") value = "0";
                    value = Math.max(
                      0,
                      Math.min(Number(value), max),
                    ).toString();
                    setEnterQty(value);
                  }}
                />
              </div>
            )}
          </div>
          <br />
          {editableBatchRows && editableBatchRows.length > 0 && (
            <div style={{ overflowX: "auto" }}>
              <div>
                <hr className="vertical-line-alignment" />
              </div>
              <table
                style={{
                  width: "70%",
                  borderCollapse: "separate",
                }}
              >
                <thead>
                  <tr>
                    <th className="batch-text-field">batch number</th>
                    <th className="batch-text-field">Expiry Date</th>
                    <th
                      className="batch-text-field"
                      style={{ width: "205px", textAlign: "left" }}
                    >
                      batch Verified
                    </th>
                    <th className="batch-text-field">Released Stock</th>
                    <th className="batch-text-field">Received Stock</th>
                    <th className="batch-text-field"></th>
                  </tr>
                </thead>
                <tbody>
                  {editableBatchRows && editableBatchRows.length > 0 ? (
                    editableBatchRows.map((row, index) => (
                      <tr
                        key={row.id || index}
                        style={
                          String((row && row.batch_no) || "").toLowerCase() ===
                          String(highlightedBatchNo || "").toLowerCase()
                            ? {
                                backgroundColor: "#fff3cd",
                                borderRadius: "10px",
                              }
                            : undefined
                        }
                      >
                        <td className="batch-padding-style">
                          {row.batch_no || "-"}
                        </td>
                        <td className="batch-padding-style">
                          {row.expiry_date || "-"}
                        </td>
                        <td className="remaining-warehouse-stock-td-style">
                          {Number(row && row.release_qty) === 0 ||
                          (row && row.is_deducted) ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                // justifyContent: "flex-start",
                                gap: "6px",
                                color: "#50b557",
                                fontWeight: "700",
                                fontSize: "16px",
                              }}
                            >
                              <i
                                className="fa fa-check-circle"
                                style={{ color: "#50b557", fontSize: "20px" }}
                              ></i>
                              <span style={{ fontsize: "16px" }}>Yes</span>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                // justifyContent: "flex-start",
                                gap: "6px",
                                color: "#ff9800",
                                fontWeight: "700",
                                fontSize: "16px",
                              }}
                            >
                              <i
                                className="fa fa-spinner fa-spin"
                                style={{
                                  color: "#ff9800",
                                  fontSize: "18px",
                                }}
                              ></i>
                              Verifying...
                            </div>
                          )}
                        </td>
                        <td className="release-qty-td-style">
                          <FormControl
                            style={{
                              fontWeight: "800",
                              fontSize: "16px",
                              textAlign: "center",
                              border:
                                Number(row.release_qty) <
                                (Number(row.quantity) || 0)
                                  ? "2px solid red"
                                  : "",
                              backgroundColor:
                                Number(row.release_qty) <
                                (Number(row.quantity) || 0)
                                  ? "rgb(255, 191, 168)"
                                  : "",
                            }}
                            type="number"
                            min="0"
                            max={Number(row.quantity) || 0}
                            value={row.release_qty}
                            onChange={(e) =>
                              updateBatchValue(
                                index,
                                "release_qty",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td className="release-qty-td-style">
                          <FormControl
                            style={{
                              fontWeight: "800",
                              fontSize: "16px",
                              textAlign: "center",
                              border:
                                Number(row.received_qty) > 0
                                  ? "2px solid rgb(80, 181, 87)"
                                  : "",
                              backgroundColor:
                                Number(row.received_qty) > 0
                                  ? "rgb(229, 255, 232)"
                                  : "",
                            }}
                            type="number"
                            min="0"
                            max={Number(row.quantity) || 0}
                            value={row.received_qty}
                            onFocus={() => {
                              if (String(row.received_qty) === "0") {
                                updateBatchValue(index, "received_qty", "");
                              }
                            }}
                            onChange={(e) =>
                              updateBatchValue(
                                index,
                                "received_qty",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        style={{ textAlign: "center", fontWeight: 400 }}
                      >
                        No batch data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-danger"
          onClick={handleCancel}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PharmacyVerifiedModal;
